import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import CartButton from "../cart/CartButton";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
  { label: "Produits", href: "/produits" },
  { label: "Témoignages", href: "/#temoignages" },
  { label: "Contact", href: "/#contact" }];


  return (
    <nav
      data-testid="navbar"
      className={`sticky top-0 z-50 transition-all duration-300 ${
      scrolled ?
      "bg-[#F5F0E8]/95 backdrop-blur-md shadow-md" :
      "bg-[#F5F0E8]/80 backdrop-blur-sm"} border-b border-stone-200/50`
      }>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20 md:h-28">
          {/* Logo */}
          <a
            href="/"
            data-testid="navbar-logo"
            className="flex items-center">

            <img
              src="https://customer-assets.emergentagent.com/job_kacinoe-health-shop/artifacts/d94t0l0x_Logo%20Sante%20Kacinoe.png"
              alt="Santé KACINOÉ"
              className="h-16 md:h-24 w-auto object-contain !rounded-b-[1px]" />

          </a>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => {
              const isRoute = link.href.startsWith("/") && !link.href.startsWith("/#");
              return isRoute ? (
                <Link
                  key={link.href}
                  to={link.href}
                  data-testid={`nav-link-${link.label.toLowerCase()}`}
                  className="text-stone-700 hover:text-[#6C3FC5] transition-colors duration-200 text-sm font-medium tracking-wide"
                >
                  {link.label}
                </Link>
              ) : (
                <a
                  key={link.href}
                  href={link.href}
                  data-testid={`nav-link-${link.label.toLowerCase()}`}
                  className="text-stone-700 hover:text-[#6C3FC5] transition-colors duration-200 text-sm font-medium tracking-wide"
                >
                  {link.label}
                </a>
              );
            })}
            <CartButton variant="navbar" />
          </div>

          {/* Mobile: cart + menu toggle */}
          <div className="flex items-center gap-2 md:hidden">
            <CartButton variant="navbar" />
            <button
              data-testid="navbar-mobile-toggle"
              className="p-2 text-stone-700 hover:text-[#6C3FC5]"
              onClick={() => setIsOpen(!isOpen)}>

              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {isOpen &&
        <div data-testid="navbar-mobile-menu" className="md:hidden pb-4 border-t border-stone-200/50">
            <div className="flex flex-col gap-3 pt-4">
              {navLinks.map((link) => {
                const isRoute = link.href.startsWith("/") && !link.href.startsWith("/#");
                return isRoute ? (
                  <Link
                    key={link.href}
                    to={link.href}
                    onClick={() => setIsOpen(false)}
                    className="text-stone-700 hover:text-[#6C3FC5] transition-colors px-2 py-2 text-base font-medium"
                  >
                    {link.label}
                  </Link>
                ) : (
                  <a
                    key={link.href}
                    href={link.href}
                    onClick={() => setIsOpen(false)}
                    className="text-stone-700 hover:text-[#6C3FC5] transition-colors px-2 py-2 text-base font-medium"
                  >
                    {link.label}
                  </a>
                );
              })}
              <a
              href="https://wa.me/2250716421345?text=Bonjour, je souhaite passer une commande"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="navbar-mobile-cta"
              className="inline-flex items-center justify-center gap-2 bg-[#25D366] text-white px-6 py-3 rounded-full text-sm font-medium mt-2">
                <i className="fab fa-whatsapp"></i>
                Contact WhatsApp
              </a>
            </div>
          </div>
        }
      </div>
    </nav>);

}